<template>
  <div class="flex border-r border-grey-lightest border-solid flex-col pin-l justify-between container">
    <template v-if="isActiveChat">
      <!-- Header -->
      <div class="flex flex-row h-12 bg-white justify-between border-solid border-b border-grey-lightest px-4">
        <div class="flex flex-col flex-no-shrink self-center mr-auto">
          <div class="flex flex-row text-sm items-baseline">
            <div class="flex font-semibold mr-1 text-grey-darker capitalize items-center" :title="customer.name">{{customer.name}}</div>
            <div v-if="customer.isOnline === true" class="bg-green self-center flex-no-shrink flex-no-grow mr-2" style="height:10px; width: 10px; border-radius: 50%" />
            <div v-else-if="customer.isOnline === false" class="bg-red self-center flex-no-shrink flex-no-grow mr-2" style="height:10px; width: 10px; border-radius: 50%" />
            <div class="text-grey-dark font-light text-xs mr-1">{{dateToAge}}</div>
            <div class="text-grey-dark text-xs">{{gender}}</div>
          </div>
          <div class="flex flex-row text-sm items-baseline" >
            <div class="text-grey-darker text-xs pt-1 mr-1">{{customer.customerId}}</div>
            <div class="text text-xl mr-1 h-1 w-1 rounded-full bg-black"></div>
            <div class="text-grey-darker text-xs pt-1">{{companyName(customer)}}</div>
          </div>
        </div>
        <div class="relative flex flex-row self-center flex-no-shrink flex-no-grow mx-1">
          <div class="flex flex-row self-center">
            <div v-if="customer.isFamilyDoctor" class="flex py-2 pl-2 pr-3 h-8 self-center text-sm items-center" style="border-radius: 25px;color:#1b7042; background-color:#c4f1d8" >
              <div class="flex"><img class="w-5" src="../../assets/personal_patient.svg" alt="Personal Patient"></div>
              <div class="ml-2">Your Patient</div>
            </div>
            <div v-else class="flex bg-grey-lightest h-8 text-dark text-sm py-2 px-3" style="border-radius: 25px" >Family Doctor:&nbsp<p class="font-semibold">{{customer.familyDoctor && customer.familyDoctor.name ? customer.familyDoctor.name : 'NA'}}</p></div>
          </div>
        </div>
        <div class="flex flex-row self-center ml-auto" :class="timerClass">
          <div class="flex h-8 text-md px-3 font-semibold items-center rounded-full pb-px" :class="timerBg" ><p>Elapsed time:&nbsp</p>{{minutes}}m {{seconds}}s</div>
        </div>
        <!--END Relative container Class-->
        <div class="flex flex-row self-center ml-2">
          <div title="End Chat" @click="endConsultation('endChatClicked')" class="hover:shadow-md flex flex-col self-center justify-center mx-4 items-center ml-auto h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-white bg-green"><i class="fa fa-xs pl-1 fa-check"></i></div>
          <!-- <div v-if="(customer.isFamilyDoctor && customer.consultationRequest.status !== 'query_accepted') || customer.consultationRequest.status === 'accepted'" title="Incomplete Chat" @click="endConsultation('incompleteChatClicked')" class="hover:shadow-md flex flex-col self-center justify-center mx-4 items-center ml-auto h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-white bg-red"><i class="fa fa-xs pl-1 fa-times"></i></div> -->
          <div title="Incomplete Chat" @click="endConsultation('incompleteChatClicked')" class="hover:shadow-md flex flex-col self-center justify-center mx-4 items-center ml-auto h-6 w-6 rounded-full flex-no-grow flex-no-shrink pr-1 cursor-pointer text-white bg-red"><i class="fa fa-xs pl-1 fa-times"></i></div>
          <div @click="viewCustomerProfile($event)" class="flex self-center text-blue text-xs flex-no-shrink flex-no-grow cursor-pointer font-semibold"> View Profile </div>
          <!--End Chat confirmation Popup -->
          <div v-if="endChatClicked || incompleteChatClicked">
            <div id="overlay" @click="closeEndChatOverlay()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
            <!--VALID Confirmation pop up when ending consultation-->
            <div v-if="endChatClicked" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
              <div class="flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest">
                <div class="flex flex-row mb-2 justify-between items-center">
                  <div class="align-center text-lg text-left font-semibold py-2"> Ending this consultation as valid</div>
                  <img @click="closeEndChatOverlay()" class="w-6 h-6 cursor-pointer" src="../../assets/close.png">
                </div>
                <label class="text-grey-darker font-light text-xs">Are you sure you want to end this consult?</label>
                <div class="flex flex-row mt-3 mb-2 justify-start">
                  <div v-on:click="endChat('SUCCESS')" class="flex flex-col bg-blue font-semibold px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Yes</div>
                  <div v-on:click="closeEndChatOverlay()" class="flex flex-col bg-white font-semibold ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-blue text-sm hover:shadow-md border border-solid border-grey-lightest">No</div>
                </div>
              </div>
            </div>
            <!--INVALID Confirmation pop up when ending consultation-->
            <div v-if="incompleteChatClicked" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;"> <!--display none-->
              <div class="flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest">
                <div class="flex flex-row mb-2 justify-between items-center">
                  <div class="align-center text-lg text-left font-semibold py-2"> Ending this consultation as invalid</div>
                  <img @click="closeEndChatOverlay()" class="w-6 h-6 cursor-pointer" src="../../assets/close.png">
                </div>
                <label class="text-grey-darker font-light text-xs">Reason for ending the consult as invalid</label>
                <div @input="onDivInput($event)" id="editor" contenteditable="true" class="border border-grey-lightest text-grey-darker text-sm border-solid rounded-sm px-1 py-2 my-2 focus:border-blue" style="outline: none; max-height: 150px; overflow-y: auto"></div>
                <div class="flex flex-row mt-3 mb-2 justify-between">
                  <div class="text-xs text-grey-darker self-center"><input v-model="noMessage" type="checkbox" name="no_messsage" value="0"> &nbsp;No Message Exchanged</div>
                  <div v-on:click="endChat('FAILURE')" class="flex flex-col bg-blue px-4 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md">Submit</div>
                </div>
              </div>
            </div>
          </div>
          <!-- END  -->
        </div>
        <!--START Chat Actions Modal--> <!--display is none-->
        <!-- <div class="relative flex self-center ml-2">
        <img class="h-5 w-5 self-center cursor-pointer" src="../assets/ellipses.png" alt="more options">
          <div class="absolute flex flex-col bg-white shadow rounded-sm w-64 h-auto z-20" style="top: 40px; right: 0px; display: none">
            <div class="flex flex-col justify-center hover:bg-grey-lighter px-4 py-4 cursor-pointer border-b border-solid border-grey-lighter">
              <div class= text-green text-base pb-1">Valid <i class="fa fa-xs pl-1 fa-check"></i></div>
              <div class="text-grey-dark font-light text-xs">Session will be marked as complete</div>
            </div>
            <div class="flex flex-col justify-center hover:bg-grey-lighter px-4 py-4 cursor-pointer border-b border-solid border-grey-lighter">
              <div class= text-red text-base pb-1">Invalid <i class="fa fa-xs pl-1 fa-times"></i></div>
              <div class="text-grey-dark font-light text-xs">Session will be marked as incomplete</div>
            </div>
            <div class="flex flex-col justify-center px-4 py-3">
              <div class="font-semibold text-grey-darkest text-sm pb-1">Transfer to other Doctor</div>
              <div class="text-grey-dark font-light text-xs pb-1">Transfer this patient to an available Doctor</div>
              <div class="bg-blue text-sm text-white font-light px-4 py-2 rounded-sm mt-2 mb-1 self-start hover:shadow hover:bg-blue-dark cursor-pointer">Check Availability</div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Messages -->
      <chat-message-container :messages="messages" :isActiveChat="isActiveChat"/>

      <!--chat_input_section-->
      <div class="flex flex-row relative pin-b p-2 flex-no-shrink flex-no-grow border-t border-solid border-grey-lightest bg-white overflow-auto" style="min-height: 3.2rem">
        <textarea :value="message" @input="sendTyping" v-on:blur="sendNotTyping" v-on:keyup.enter="addMessage" type="text" class="p-2 pr-12 m-2 relative bg-grey-extralight rounded-m border border-solid border-grey-lightest borderRadius-m text-base text-grey-darkest" style="outline: none; overflow-y: auto; text-overflow: auto; line-height: 1; width: 100%; resize: none;" row="3"/>
        <div class="self-center h-10 w-10" style="position: absolute; right: 100px; z-index: 1">
          <speech-recognition @getVoiceMessage="getVoiceMessage" :message="message"/>
        </div>
        <!-- <div class="h-6 w-6 self-center mx-2" style="position: absolute; right: 100px;">
          <div class="db-file-upload">
            <div class="file">
              <label class="file-label">
                <input class="file-input" style="display:none" accept=".pdf, .png, .jpg, .jpeg" type="file" name="chatfile" id="file" ref="myFiles" @change="chatFileUpload($event.target.name, $event.target.files)">
                <img src="../assets/attach.svg" alt="attach_file" class="cursor-pointer">
              </label>
            </div>
          </div>
        </div> -->
        <div v-on:click="addMessage" class="hover:shadow-md bg-blue my-2 mr-2 text-white font-semibold text-center rounded self-center flex-no-shrink cursor-pointer" style="padding: 15px 16px"> Send </div>
      </div>
    </template>
    <template v-if="isActivePastChat">
      <!-- Header -->
      <div class="flex flex-row h-12 bg-white justify-between border-solid border-b border-grey-lightest px-4">
        <div class="flex flex-col flex-no-shrink self-center">
          <div class="flex flex-row text-sm items-baseline">
            <div class="font-semibold mr-2 capitalize" :title="customer.name">{{pastCustomer.name}}</div>
            <div class="text-grey-dark font-light text-xs mr-1">{{PCdateToAge}}</div>
            <div class="text-grey-dark text-xs">{{PCgender}}</div>
          </div>
          <div class="flex flex-row text-sm items-baseline" >
            <div class="text-grey-darker text-xs pt-1 mr-1">{{pastCustomer.customerId}}</div>
            <div class="text text-xl mr-1 h-1 w-1 rounded-full bg-black"></div>
            <div class="text-grey-darker text-xs pt-1">{{companyName(pastCustomer)}}</div>
          </div>
        </div>
        <div class="relative flex flex-row self-center mx-auto">
          <div class="flex flex-row self-center flex-no-shrink flex-no-grow mx-1">
              <!-- <div @click="viewCustomerProfile($event)" class="relative text-blue text-xs flex-no-shrink flex-no-grow cursor-pointer"> View Profile </div> -->
              <div v-if="pastCustomer.isFamilyDoctor" class="flex py-2 px-3 h-8 self-center text-sm items-center" style="border-radius: 25px;color:#1b7042; background-color:#c4f1d8" >
                <div class="flex"><img class="w-5" src="../../assets/personal_patient.svg" alt="Personal Patient"></div>
                <div class="ml-2">Your Patient</div>
              </div>
              <div v-else class="flex bg-grey-lightest h-8 text-dark text-sm py-2 px-3" style="border-radius: 25px" >Family Doctor:&nbsp<p class="font-semibold">{{pastCustomer.familyDoctor && pastCustomer.familyDoctor.name ? pastCustomer.familyDoctor.name : 'NA'}}</p></div>
          </div>
        </div>
        <div @click="viewCustomerProfile($event)" class="flex self-center text-blue text-xs flex-no-shrink flex-no-grow cursor-pointer font-semibold"> View Profile </div>

      </div>

      <!-- Messages -->
      <chat-message-container :messages="pastCustomer.messages" :isActivePastChat="isActivePastChat" />

      <!-- Summary buttons -->
      <div class="flex flex-row h-12 bg-white justify-center border-solid border-t border-grey-lightest px-4">  
        <div v-if="!consultStatus" @click="reviewSummary" class="hover:shadow-md cursor-pointer self-center bg-green p-2 rounded text-white font-light ml-2 text-sm font-semibold px-4">Write Summary</div>
      </div>
    </template>
    <customer-profile v-if="viewProfile" @viewCustomerProfile="viewCustomerProfile" />
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import SpeechRecognition from '@/components/common/SpeechRecognition'
import CustomerProfile from '@/components/Customer/CustomerProfile'
import ChatMessageContainer from '@/components/Chat/ChatMessageContainer'
import TimeElapsed from '../Consultations/TimeElapsed.vue'

export default {
  components: {
    SpeechRecognition,
    CustomerProfile,
    ChatMessageContainer,
    TimeElapsed
  },
  data () {
    return {
      // progress: 0,
      chatInput: this.inputMessage,
      viewProfile: false,
      endChatClicked: false,
      incompleteChatClicked: false,
      noMessage: false,
      reasons: null,
      sendNotifiactionTimeout: null,
      timerClass: 'text-green-darker',
      timerBg: 'bg-green-lightest',
      minutes: 0,
      seconds: 0,
      interval: null,
      intervals: {
        second: 1000,
        minute: 1000 * 60,
        hour: 1000 * 60 * 60,
        day: 1000 * 60 * 60 * 24
      }
    }
  },
  computed: {
    ...mapGetters({
      isActiveChatPresent: 'consultation/isActiveChatPresent',
      customer: 'consultation/getActiveUserProfile',
      pastCustomer: 'pastConsultation/getActivePastCustomer',
      isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
      messages: 'message/getMessages',
      loader: 'loader/getLoaderData',
      activeSection: 'configuration/getActiveSection',
      inputMessage: 'consultation/getInputMessage'
    }),
    message: {
      get () {
        return this.chatInput
      },
      set (value) {
        this.updateInput(value)
      }
    },
    chatHeaderText: function () {
      if (this.customer.isFamilyDoctor) {
        return 'Your Patient'
      } else {
        return 'Family Doctor: ' + this.customer.familyDoctor && this.customer.familyDoctor.name ? this.customer.familyDoctor.name : 'NA'
      }
    },
    dateToAge: function () {
      if (this.customer.details && this.customer.details.date_of_birth) {
        let dateOfBirth = this.customer.details.date_of_birth
        if (!(isNaN(dateOfBirth)) || new Date(dateOfBirth).toString() === 'Invalid Date') {
          return -1
        } else {
          var birth = new Date(dateOfBirth)
          var curr = new Date()
          var diff = curr.getTime() - birth.getTime()
          return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25))
        }
      }
    },
    gender: function () {
      if (this.customer.details && this.customer.details.gender) {
        return this.customer.details.gender
      }
    },
    PCdateToAge: function () {
      if (this.pastCustomer.details && this.pastCustomer.details.date_of_birth) {
        let dateOfBirth = this.pastCustomer.details.date_of_birth
        if (!(isNaN(dateOfBirth)) || new Date(dateOfBirth).toString() === 'Invalid Date') {
          return -1
        } else {
          var birth = new Date(dateOfBirth)
          var curr = new Date()
          var diff = curr.getTime() - birth.getTime()
          return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25))
        }
      }
    },
    PCgender: function () {
      if (this.pastCustomer.details && this.pastCustomer.details.gender) {
        return this.pastCustomer.details.gender
      }
    },
    isActiveChat: function () {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return true
      }
      return false
    },
    isActivePastChat: function () {
      if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return true
      }
      return false
    },
    consultStatus: function () {
      let consult = this.pastCustomer && this.pastCustomer.consultation ? this.pastCustomer.consultation : null
      if (consult) {
        if ((consult.summary_status === 'done' || consult.summary_status === 'not_needed') || (consult.consultationId === null || consult.consultationId === undefined)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  mounted () {
    this.missedRequestMessage()
    this.interval = setInterval(() => {
      this.updatedTime()
    }, 1000)
  },
  destroyed () {
    clearInterval(this.interval)
  },
  watch: {
    ...mapState({
      input: state => state.consultation.messages
    }),
    customer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.missedRequestMessage()
        this.sendNotifiactionTimeout = null
      }
      if (newVal.isOnline && this.sendNotifiactionTimeout) {
        clearTimeout(this.sendNotifiactionTimeout)
      }
    },
    messages: function (newV, oldV) {
      if (newV !== oldV) {
        this.missedRequestMessage()
      }
    }
  },
  methods: {
    updateInput: function (value) {
      let msg = {
        channelId: this.customer.channelId,
        message: this.inputMessage ? this.inputMessage : value
      }
      this.chatInput = this.inputMessage
      if (this.inputMessage.length > 0) {
        this.$store.dispatch('consultation/storeMessage', msg)
      }
    },
    companyName: function (cus) {
      if (cus.details && cus.details.company_name) {
        if (cus.details.company_name.length > 25) {
          return cus.details.company_name.substring(0, 25) + '...'
        } else {
          return cus.details.company_name
        }
      } else return 'NA'
    },
    missedRequestMessage: function () {
      this.message = ''
      if (this.customer && this.customer.consultationRequest && this.customer.consultationRequest.request_type === 'missed' && this.messages.length < 3) {
        this.message = `Hi ${this.customer.name}, sorry to miss your consultation request. Good to connect with you today.`
      }
    },
    getVoiceMessage: function (message) {
      this.chatInput = message
      let msg = {
        channelId: this.customer.channelId,
        message: message
      }
      this.$store.dispatch('consultation/storeMessage', msg)
    },
    getDocument: function (doctype, docid) {
      let type = 'medical_records'
      if (doctype === 'Prescription') {
        type = 'prescriptions'
      }
      this.$http.get(window.API_URL + 'doctors/' + type + '/' + docid + '/download').then(response => {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank')
        } else {
          alert('Error fetching data')
        }
      }, response => {
      })
    },
    onDivInput: function (e) {
      this.reasons = document.getElementById('editor').innerText
    },
    viewCustomerProfile: function (e) {
      e.stopPropagation()
      this.viewProfile = !this.viewProfile
    },
    endConsultation: function (item) {
      this[item] = true
    },
    closeEndChatOverlay: function () {
      this.endChatClicked = false
      this.incompleteChatClicked = false
    },
    addMessage: function () {
      if (this.message.trim().length > 0) {
        this.$store.dispatch('message/send', {message: this.message, intentName: 'incoming_text', channelId: this.customer.channelId})
        this.$store.commit('consultation/updateInputMessage', {channelId: this.customer.channelId})
        this.message = ''
        this.chatInput = ''
      }
      let msg = {
        channelId: this.customer.channelId,
        message: ''
      }
      this.$store.dispatch('consultation/storeMessage', msg)
    },
    sendTyping: function (e) {
      let message = e.target.value
      this.chatInput = message
      let msg = {
        channelId: this.customer.channelId,
        message: message
      }
      if (message !== '' && message.length % 5 === 0) {
        this.$store.dispatch('consultation/sendDoctorTyping', true)
      } if (message !== '') {
        this.$store.dispatch('consultation/storeMessage', msg)
      }
      if (message.length > 1) {
        this.$store.dispatch('consultation/storeMessage', msg)
      }
    },
    sendNotTyping: function () {
      this.$store.dispatch('consultation/sendDoctorTyping', false)
    },
    chatFileUpload: function (fieldName, fileList) {
      this.$store.dispatch('message/uploadDocument', {fileList: fileList})
    },
    endChat: function (status) {
      var reasons = []
      if (this.reasons !== null) {
        reasons.push(this.reasons)
      }
      if (this.noMessage) {
        reasons.push('No Message Exchanged')
      }
      this.$store.dispatch('consultation/endChat', {status: status, reasons: reasons})
      this.closeEndChatOverlay()
    },
    summaryNotNeeded: function () {
      this.$store.dispatch('pastConsultation/summaryNotNeeded', {summary: 'NA', componentKey: 'CP-SummaryNotNeeded'})
    },
    reviewSummary: function () {
      this.$emit('tabChange', 'consultation-summary')
    },
    timerColor: function (value) {
      this.timerClass = value
      if (value === 'text-green-darker') {
        this.timerBg = 'bg-green-lightest'
      } else if (value === 'text-yellow-darker') {
        this.timerBg = 'bg-yellow-lighter'
      } else if (value === 'text-red-dark') {
        this.timerBg = 'bg-red-lightest'
      }
    },
    updatedTime () {
      let date = new Date(this.customer.accepted_at)
      let diff = Math.abs(Date.now() - date.getTime())
      this.days = Math.floor(diff / this.intervals.day)
      diff -= this.days * this.intervals.day
      this.hours = Math.floor(diff / this.intervals.hour)
      diff -= this.hours * this.intervals.hour
      this.minutes = Math.floor(diff / this.intervals.minute)
      diff -= this.minutes * this.intervals.minute
      this.seconds = Math.floor(diff / this.intervals.second)

      if (this.minutes >= 10 && this.minutes < 15) {
        this.timerClass = 'text-yellow-darker'
        this.timerBg = 'bg-yellow-lighter'
      } else if (this.minutes >= 15) {
        this.timerClass = 'text-red-dark'
        this.timerBg = 'bg-red-lightest'
      } else {
        this.timerClass = 'text-green-darker'
        this.timerBg = 'bg-green-lightest'
      }
    }
  }
}
</script>

<style scoped>
.container {
  background-image: url('../../assets/chat-background.jpg');
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/Chat/ChatPane.vue